import React from "react";

import { CCard, CCol, CRow, CCardTitle } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";

import { COLORS } from "src/constants/Colors";

const UpToDate = () => {
  return (
    <CRow>
      <CCol>
        <CCard className="p-4">
          <CCardTitle className="d-flex justify-content-center">
            {" "}
            You are up to date.
          </CCardTitle>
          <CIcon
            content={freeSet.cilCheck}
            customClasses="c-sidebar-nav-icon"
            style={{ color: COLORS.iStaffGreen }}
          />
        </CCard>
      </CCol>
    </CRow>
  );
};

export default UpToDate;
